import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

/** Запрос сотрудников текущей организации сотрудника */
export const GetDepartmentsPublic = () =>
  API.get(`/${C300}/models/departments_public/`);

/** Поиск сотрудников по номеру телефона */
export const GetWorkersCardsByPhone = (params: IParams) => {
  return API.get(`/${C300}/models/workers/`, undefined, params);
};

/** Запрос сотрудников провайдеров, создавших документы для ркц (для Документооборота) */
export const GetDocsDepartments = () =>
  API.get(`/${C300}/models/docs_departments/`);

/** Смена права контроля в обращениях */
export const ChangeTicketsAccess = (workerID: string, params: IParams) =>
  API.gatewayPatch(
    `/${C300}/models/worker/change_tickets_access_level/`,
    workerID,
    params
  );
